import React, { FC } from 'react'
import { Layout as LayoutTemplate, LayoutProps } from '@flint/core'
import { useLinks } from '@/hooks/useLinks'

export const Layout: FC<LayoutProps> = (props) => {
  const links = useLinks()

  return <LayoutTemplate {...props} links={links} />
}
